module.exports = __webpack_public_path__ + "static/img/1582.86db034.png";